import flatpickr from 'flatpickr';

export default function initDatepicker(selector, config = {}) {
  return flatpickr(selector, config);
}



// WEBPACK FOOTER //
// ./js/components/Datepicker.js